import { enableProdMode, StaticProvider } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { defineCustomElements } from "@liebherr/patternlib";
import LiebherrAuth from "@liebherr/spa-auth";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

const baseUrl = getBaseUrl();

if (environment.production) {
  enableProdMode();
} else {
  // Log debug information to the console.
  LiebherrAuth.enableLog = true;
}

LiebherrAuth.fetchSettingsFromUrl(`${baseUrl}auth.conf.json`).then(
  (settings) => {
    // Make sure you've copied these files into your assets folder.
    settings.redirectUri = `${baseUrl}auth-callback.html`;
    settings.silentRedirectUri = `${baseUrl}silent-refresh.html`;

    const auth = new LiebherrAuth(settings);
    auth.login().then(() => {
      const providers = <StaticProvider[]>[
        { provide: "BASE_URL", useFactory: getBaseUrl, deps: [] },
        { provide: "LH_AUTH", useValue: auth, deps: [] },
        {
          provide: "ENVIRONMENT_NAME",
          useValue: settings.environment,
          deps: [],
        },
      ];

      console.log("Auth done. Bootstrap application...");

      platformBrowserDynamic(providers)
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));

      defineCustomElements();
    }, console.error);
  },
  console.error,
);
